<template>
  <v-card class="pa-5 mb-6 grey lighten-4" outlined>
    <v-row no-gutters>
      <v-col md="5">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.cancelModal.code') }}
        </h6>
        {{ appointment.code }}
      </v-col>
      <v-col md="7">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.cancelModal.type') }}
        </h6>
        {{ $t(`type.${appointment.type}`) }}
      </v-col>
    </v-row>
    <v-divider class="my-4" />
    <v-row no-gutters>
      <v-col :md="appointment.visitor_name ? 5 : 12">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.cancelModal.date') }}
        </h6>
        {{ formatDate(appointment.date) }}
      </v-col>
      <v-col md="7" v-if="appointment.visitor_name">
        <h6 class="text-uppercase grey--text">
          {{ $t('appointment.cancelModal.visitor') }}
        </h6>
        {{ appointment.visitor_name }}
      </v-col>
    </v-row>
    <div v-if="visibleAddressCases.includes(appointment.type)">
      <v-divider class="my-4" />
      <h6 class="text-uppercase grey--text">
        {{ $t('appointment.cancelModal.meetingLocation') }}
      </h6>
      {{ appointment.meeting_location_description }}
    </div>
  </v-card>
</template>

<script>
import { catalogDate } from '@/util/catalog'
import { visibleAddressCases } from './../formFieldsCreate/appointmentFormDefaults'

export default {
  name: 'AppointmentFormDetails',

  props: {
    appointment: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      formatDate: catalogDate,
      visibleAddressCases,
    }
  },
}
</script>
